/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 手荷物ルール詳細情報<br/> ※手荷物ルールが取得できなかった、または予約情報がInvoluntary Reissue済み(PNR情報のイレギュラー事由で再発券済みの航空券であるかがtrue)の場合は返却しない。
 */
export interface FareConditionsResponseDataBaggagePolicies {
  /**
   * ルール種別<br/> IATA RESO 302：IATA302<br/> USDOT：US-DOT<br/> CADOT：CTA
   */
  policyRegulations?: FareConditionsResponseDataBaggagePolicies.PolicyRegulationsEnum;
  /**
   * 手荷物ルール
   */
  baggageAllowance?: object;
}
export namespace FareConditionsResponseDataBaggagePolicies {
  export type PolicyRegulationsEnum = 'IATA RESO 302' | 'USDOT' | 'CADOT';
  export const PolicyRegulationsEnum = {
    IataReso302: 'IATA RESO 302' as PolicyRegulationsEnum,
    Usdot: 'USDOT' as PolicyRegulationsEnum,
    Cadot: 'CADOT' as PolicyRegulationsEnum,
  };
}
